import { Portal } from '@radix-ui/react-alert-dialog';

export const AlertDialogPortal = Portal;
